export type BookingMohallaSource = {
  displayMohalla?: string | null;
  mohalla?: string | null;
};

/** Prefer API-hydrated displayMohalla (from linked raza), then mohalla on the payload. */
export function resolveBookingDisplayMohalla(
  source: BookingMohallaSource | undefined | null
): string | undefined {
  const display = typeof source?.displayMohalla === "string" ? source.displayMohalla.trim() : "";
  if (display) {
    return display;
  }
  const mohalla = typeof source?.mohalla === "string" ? source.mohalla.trim() : "";
  return mohalla || undefined;
}
